import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { IonApp, IonRouterOutlet, IonItem, IonHeader, IonToolbar, IonMenu, IonTitle, IonContent, IonList, } from '@ionic/angular/standalone';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './services/auth.interceptor'; // Ajuste o caminho conforme necessário
import { Storage } from '@ionic/storage-angular'; // Importa o serviço de Storage do Ionic
import { SyncService } from './services/storage-service/sync.service';
import { Router, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from './services/auth.service';
import { SecureCredentialsService } from './services/credenciais-service/SecureCredentialsService';
import { isPlatform } from '@ionic/angular';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  standalone: true,
  imports: [IonList, IonContent, IonTitle, IonToolbar, IonHeader, IonItem, CommonModule, IonApp, IonMenu, IonRouterOutlet,
    RouterLink, HttpClientModule

  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
})
export class AppComponent implements OnInit {

  isMotorista: boolean = false;
  isGerente: boolean = false;
  submenuAberto = false;
  submenuPapeletaAberto = false;
  submenuApiAberto = false;
  submenuEmpresaAberto = false;
  submenuCadastrosAberto = false;
  submenuOperacaoAberto = false;
  submenuRelatoriosAberto = false;
  submenuIntegracaoAberto = false;
  submenuRelatoriosFiscaisAberto = false;

  @ViewChild(IonMenu) menu!: IonMenu;

  private syncService = inject(SyncService);
  private router = inject(Router);
  authService = inject(AuthService);
  private secureCredentials = inject(SecureCredentialsService);

  constructor(private storage: Storage) {
    this.initStorage(); // Inicializa o armazenamento do Ionic
  }

  // Método para inicializar o Storage
  private async initStorage() {
    await this.storage.create(); // Cria a instância do storage
  }

  ngOnInit() {
    this.forceLightTheme();
    // Verifica a URL atual para definir qual menu mostrar
    this.router.events.subscribe(() => {
      const currentUrl = this.router.url;
      this.isMotorista = currentUrl.startsWith('/motorista');
      this.isGerente = currentUrl.startsWith('/gerente');
    });

  }

  private forceLightTheme() {
    // Remove qualquer classe 'dark' que possa ter sido adicionada
    document.body.classList.remove('dark');
    document.body.classList.remove('ion-palette-dark');

    // Adiciona a classe 'light' para garantir (opcional)
    document.body.classList.add('light');

    // Para garantir que o tema claro seja aplicado mesmo com prefers-color-scheme
    document.documentElement.style.colorScheme = 'light';
  }

  // Método para fechar o menu ao clicar em um item
  fecharMenu() {
    this.menu.close();
  }

  logout() {

    if (isPlatform('hybrid')) {
      this.secureCredentials.clearCredentials();
      console.log('🗑️ Credenciais removidas no logout do gerente');
    }
    // Fecha o menu antes de sair
    localStorage.removeItem('token');
    localStorage.removeItem('identificador');
    this.fecharMenu();

    // Limpa os dados armazenados no localStorage e sessionStorage
    localStorage.clear();
    sessionStorage.clear();

    // Navega para a tela de login
    /*this.router.navigate(['']).then(() => {
      // Recarrega a página completamente, como se tivesse apertado Ctrl+R ou F5
      window.location.href = window.location.href;
    });*/

    this.router.navigate(['/auth/login'], { queryParams: { retaguarda: true } });

  }

  logoutGerente() {
    // Fecha o menu antes de sair
    localStorage.removeItem('token');
    localStorage.removeItem('identificador');
    this.fecharMenu();

    // Limpa os dados armazenados no localStorage e sessionStorage
    localStorage.clear();
    sessionStorage.clear();

    // Navega para a tela de login com o parâmetro retaguarda=true
    this.router.navigate(['/auth/login'], { queryParams: { retaguarda: true } });
  }

  toggleSubmenu() {
    if (!this.submenuAberto) {
      this.fecharTodosSubmenus();
    }
    this.submenuAberto = !this.submenuAberto;
  }

  toggleSubmenuPapeleta() {
    if (!this.submenuPapeletaAberto) {
      this.fecharTodosSubmenus();
    }
    this.submenuPapeletaAberto = !this.submenuPapeletaAberto;
  }

  toggleSubmenuApi() {
    if (!this.submenuApiAberto) {
      this.fecharTodosSubmenus();
    }
    this.submenuApiAberto = !this.submenuApiAberto;
  }

  toggleSubmenuEmpresa() {
    if (!this.submenuEmpresaAberto) {
      this.fecharTodosSubmenus();
    }
    this.submenuEmpresaAberto = !this.submenuEmpresaAberto;
  }

  toggleSubmenuCadastros() {
    if (!this.submenuCadastrosAberto) {
      this.fecharTodosSubmenus();
    }
    this.submenuCadastrosAberto = !this.submenuCadastrosAberto;
  }

  toggleSubmenuOperacao() {
    if (!this.submenuOperacaoAberto) {
      this.fecharTodosSubmenus();
    }
    this.submenuOperacaoAberto = !this.submenuOperacaoAberto;
  }

  toggleSubmenuRelatorios() {
    if (!this.submenuRelatoriosAberto) {
      this.fecharTodosSubmenus();
    }
    this.submenuRelatoriosAberto = !this.submenuRelatoriosAberto;
  }

  toggleSubmenuIntegracao() {
    if (!this.submenuIntegracaoAberto) {
      this.fecharTodosSubmenus();
    }
    this.submenuIntegracaoAberto = !this.submenuIntegracaoAberto;
  }

  abrirAjudaMotorista() {
    this.fecharMenu();
    window.open('https://innovatransit.com.br/ajudaaplicativojornada/', '_blank');
  }

  abrirAjudaRetaguarda() {
    this.fecharMenu();
    window.open('https://innovatransit.com.br/ajudaretaguarda/', '_blank');
  }

  fecharTodosSubmenus() {
    this.submenuAberto = false;
    this.submenuPapeletaAberto = false;
    this.submenuApiAberto = false;
    this.submenuEmpresaAberto = false;
    this.submenuCadastrosAberto = false;
    this.submenuOperacaoAberto = false;
    this.submenuRelatoriosAberto = false;
    this.submenuIntegracaoAberto = false;
    this.submenuRelatoriosFiscaisAberto = false;
  }

  toggleSubmenuRelatoriosFiscais() {
    this.submenuRelatoriosFiscaisAberto = !this.submenuRelatoriosFiscaisAberto;
  }
}
